<template>
	<div class="layout">
		<spaceHeader></spaceHeader>
		<div class="fixation">
			<div class="view">
				<router-view></router-view>
			</div>
		</div>
		<pubfooter></pubfooter>
		<floatButton :current="1"></floatButton>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'layout',
		data() {
			return {
			};
		},
		methods: {
			...mapMutations(['saveUserinfo']),
			fetchUserInfo() {
				this.$api.frontUserInfo({
					userId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						let userinfo = res.data
						this.saveUserinfo(userinfo)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			if (this.$store.state.hasLogin) {
				this.fetchUserInfo()
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.layout {
		width: 100%;
		background: @vue-bg-color-grey;
	}

	.fixation {
		display: flex;
		justify-content: space-between;
	}

	.view {
		width: 100%;
		margin-top: @vue-spacing-col-lg*2;
		margin-bottom: @vue-spacing-col-lg*2;
		background: @vue-bg-color;
		padding: @vue-spacing-col-lg @vue-spacing-row-lg;
		box-sizing: border-box;
	}
</style>
